import React from "react";

import { styled } from "@mui/material";

import { getMediaQuery } from "../../../../getMediaQuery";
import { useProgressBarContext } from "../../../../ProgressBarView/context/ProgressBarContext";

interface ContainerProps {
  children?: React.ReactNode;
}

export const Container = ({ children }: ContainerProps) => {
  const { cartValue } = useProgressBarContext();
  if (cartValue === undefined) return null;

  return (
    <Root className="ig-dp-container" style={{ boxSizing: "border-box" }}>
      {children}
    </Root>
  );
};

const Root = styled("div")(() => {
  const { device, hasMediaQuery } = useProgressBarContext();

  const { backgroundColor } = device.widget.styles.container;
  return {
    ...(hasMediaQuery ? getMediaQuery(device.widget) : undefined),
    display: "flex",
    flexFlow: "column",
    alignItems: "center",
    minHeight: "75px",
    justifyContent: "center",
    flexWrap: "nowrap",
    margin: "0 auto",
    backgroundColor,
    padding: "10px 30px",
    width: "350px",
  };
});
